export default function FutureGoals() {
  const goals = [
    {
      year: '2025年',
      title: '事業基盤の確立',
      items: [
        '廃校活用プロジェクトの本格稼働',
        '陸上養殖システムの安定運用',
        '地域雇用20名以上の創出'
      ]
    },
    {
      year: '2027年',
      title: '事業の拡大',
      items: [
        '複数地域での展開開始',
        '生産量の増大と販路拡大',
        '地域経済への貢献度向上'
      ]
    },
    {
      year: '2030年',
      title: '持続可能な社会モデルの確立',
      items: [
        '全国10拠点での事業展開',
        'カーボンニュートラルの達成',
        '地域創生モデルの確立と普及'
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">未来への目標</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            私たちは、明確な目標を掲げ、段階的に持続可能な地域社会の実現を目指します。
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-teal-200 transform -translate-x-1/2"></div>

          {goals.map((goal, index) => (
            <div key={index} className="relative mb-16 last:mb-0">
              <div className={`md:flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className="md:w-1/2 md:px-8">
                  <div className={`bg-white rounded-lg shadow-lg p-8 ${index % 2 === 0 ? 'md:mr-8' : 'md:ml-8'}`}>
                    <div className="flex items-center gap-4 mb-6">
                      <div className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                        {goal.year}
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">{goal.title}</h3>
                    </div>
                    <ul className="space-y-3">
                      {goal.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start gap-3">
                          <i className="ri-checkbox-circle-fill text-teal-600 text-lg mt-0.5 flex-shrink-0"></i>
                          <span className="text-sm text-gray-700">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="hidden md:flex md:w-1/2 justify-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full text-2xl font-bold shadow-lg z-10">
                    {index + 1}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-teal-50 to-green-50 rounded-lg p-10 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">私たちと共に、未来を創りませんか</h3>
            <p className="text-base text-gray-700 leading-relaxed mb-8">
              地域創生と環境保全を両立させる私たちの取り組みに、ぜひご参加ください。<br />
              地域住民の皆様、自治体の皆様、企業の皆様との協力により、<br />
              持続可能な地域社会を実現します。
            </p>

          </div>
        </div>
      </div>
    </section>
  );
}